import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { StoreAction } from 'store/actions';
import { CallbackTime } from 'store/callback/models';
import { PhonePipe } from 'shared/pipes/phone';
import { XmStore } from 'services/store';
import { FormType } from 'core/constants';
import { FormUtil } from 'core/utils/form';

@Component({
    selector: 'xm-vht-modal',
    templateUrl: 'vht.html',
    styleUrls: ['vht.scss'],
    standalone: false
})
export class XmVhtModal implements OnInit {
    public requestStep: boolean = true;
    public completeStep: boolean = false;
    public apiError: boolean = false;
    public pageData: CallbackModalData;
    public phoneNumberForm: FormGroup;
    public phoneNumberOptions: XmInputOptions;
    public submitPromise: Promise<void>;
    public phoneNumberFormControl: FormControl;

    private phonePipe: PhonePipe;
    private dialogRef: MatDialogRef<XmVhtModal>;
    private xmStore: XmStore;

    constructor(dialogRef: MatDialogRef<XmVhtModal>, xmStore: XmStore, phonePipe: PhonePipe, @Inject(MAT_DIALOG_DATA) pageData: CallbackModalData) {
        Object.assign(this, { dialogRef, xmStore, phonePipe, pageData });
    }

    public ngOnInit(): void {
        this.phoneNumberOptions = {
            template: '(999) 999-9999',
            inputId: 'phone-number',
            header: this.pageData.formLabel,
            errors: this.pageData.errors
        };

        this.phoneNumberFormControl = new FormControl('', { validators: FormUtil.validators(this.phoneNumberOptions.errors), updateOn: FormType.blur });

        this.phoneNumberForm = new FormGroup({
            phoneNumber: this.phoneNumberFormControl
        });
    }

    public close(action: string): void {
        const response: ModalResponse = {
            close: action === 'close',
            primary: action === 'primary',
            secondary: action === 'secondary',
            data: this.completeStep
        };

        this.dialogRef.close(response);
    }

    public onSubmit(): void {
        FormUtil.submitForm(this.phoneNumberForm, this.submitRequest.bind(this));
    }

    private submitRequest(): void {
        if (this.phoneNumberForm.valid) {
            this.submitPromise = this.xmStore.persist<CallbackTime>(StoreAction.SUBMIT_CALLBACK_NUMBER, this.phoneNumberFormControl.value)
                .then((response: CallbackTime) => {
                    this.pageData.completeSubhead = this.pageData.completeSubhead.replace('[PHONE_NUMBER]', this.phonePipe.transform(response.phoneNumber));

                    this.requestStep = false;
                    this.completeStep = true;
                })
                .catch(() => {
                    this.apiError = true;
                });
        }
    }
}
